import config from '@/assets/config'
import { copyFrames, getFrames } from '@/utils'

const ww = window.innerWidth
const wh = window.innerHeight

// 场景基础数据
const s1ScrollT = config.scenesScrollT[0]
// 云朵
const s1CloudD = 0
const s1CloudT = 0.7 * s1ScrollT
const s1Cloud2W = wh * 0.6847 * 2521 / 1499
const s1Cloud3W = wh * 0.5 * 3396 / 1440
const s2CloudD = 0.1 * s1ScrollT
const s2CloudT = 0.9 * s1ScrollT
// 地面
const s1GroundW = wh * 0.32 * 2000 / 432
const s1GroundScrollW = s1GroundW * 2
const s1Ground1D = 0
const s1GoundT = 1 * s1ScrollT
const s1GroundV = s1GroundScrollW / s1GoundT
const s1Ground1T = s1GroundW / s1GroundScrollW * s1GoundT
const s1Ground2D = (s1GroundW - ww) / s1GroundScrollW * s1GoundT
const s1Ground2T = (s1GroundW + ww) / s1GroundScrollW * s1GoundT
// 建筑物
const s1Static1W = wh * 0.43 * 2091 / 1051
const s1Static2W = wh * 0.63 * 4013 / 1546
const s1Static3W = wh * 0.61 * 2468 / 1489
const s1StaticScrollW = s1Static1W + s1Static2W * 0.64 + s1Static3W
const s1StaticT = 1 * s1ScrollT
const s1StaticV = s1StaticScrollW / s1StaticT
const s1Static1T = s1Static1W / s1StaticV
const s1Static1D = 0
const s1Static2X = s1Static1W > ww ? ww : (s1Static1W - s1Static2W * 0.18)
const s1Static2T = (s1Static2W + s1Static2X) / s1StaticV
const s1Static2D = (s1Static1W - s1Static2W * 0.18 - ww) < 0 ? 0 : (s1Static1W - s1Static2W * 0.18 - ww) / s1StaticV
const s1Static3T = (s1Static3W + ww) / s1StaticV
const s1Static3D = (s1Static1W + s1Static2W * 0.64 - ww) / s1StaticV
// 水
const s1Water1W = wh * 0.12 * 1587 / 298
const s1Water1ScrollW = s1Water1W + ww
const s1Water1D = 0.3 * s1ScrollT
const s1Water1T = s1Water1ScrollW / s1GroundV
// 行人
const s1WalkD = 0.5 * s1ScrollT
const s1WalkT = 0.2 * s1ScrollT
// 电线杆
const s1PoleV = s1GroundV
const s1PoleW = wh * 1912 / 2436
const s1PoleScrollW = s1PoleW + ww
const s1PoleT = s1PoleScrollW / s1PoleV
const s1PoleD = s1ScrollT - s1PoleT * 0.98
// 自行车
const s1BikeW = wh * 0.276 * 900 / 673
const s1Wheel2W = wh * 0.171
const s1BikeScrollW = ww * 0.44 + s1BikeW * 0.5 + s1Wheel2W * 0.5
const s1BikeD = s1PoleD + s1PoleT * 0.3
const s1BikeT = s1PoleT * 0.6
const s1BikeX = 0.44
const s1Wheel1X = s1BikeX - (s1BikeW * 0.251 / ww)
const s1Wheel1D = 0
const s1Wheel1T = 1 * s1ScrollT
const s1Wheel2X = s1BikeX + (s1BikeW * 0.485 / ww)
const s1Wheel2D = 0
const s1Wheel2T = 1 * s1ScrollT
const s1HandX = s1BikeX - (s1BikeW * 0.3 / ww)
const s1LegX = s1BikeX + (s1BikeW * 0.057 / ww)
const s1LegD = 0
const s1LegT = 1 * s1ScrollT
const s1MotherX = s1BikeX + (s1BikeW * 0.1067 / ww)
const s1Shadow2X = 0.5
// 水花
const s1Water2W = 0.084 * wh * 389 / 204
const s1Water2H = 0.084 * wh
const s1Water2D = s1Water1D + (s1Water1ScrollW * 0.38 / s1GroundV)
const s1Water2T = s1Water1T
const s1Water2D2 = s1Water2D + ((ww - s1BikeW) * 0.4 / s1GroundV)
const s1Water2T2 = ww * 0.15 / s1GroundV
const s1Water2D3 = s1Water2D2 + s1Water2T2 * 2
const s1Water2T3 = ww * 0.1 / s1GroundV
// 草丛
const s1GrassV = s1GroundV
const s1Grass1D = 0.32 * s1ScrollT
const s1Grass1W = wh * 0.154 * 1836 / 375
const s1Grass1T = (s1Grass1W + ww) / s1GrassV
const s1Grass2D = 0.56 * s1ScrollT
const s1Grass2W = wh * 0.485 * 2492 / 1181
const s1Grass2T = (s1Grass2W + ww) / s1GrassV

// 对话
const s1Talk1D = s1ScrollT * 0.1
const s1Talk1T = s1ScrollT * 0.05
const s1Talk1H = wh * 0.162
const s1Talk1W = s1Talk1H * 168 / 395
const s1Talk2D = s1ScrollT * 0.2
const s1Talk2T = s1ScrollT * 0.05
const s1Talk2H = wh * 0.19
const s1Talk2W = s1Talk2H * 168 / 462

const s1TextD = s1Talk2D + s1Talk2T * 6
const s1TextT = s1ScrollT * 0.06

const animations = {
  // example: [
  //   // 循环帧动画
  //   {
  //     duration: 2,
  //     frames: this.getFrames('plane', 25),
  //     infinite: true,
  //     frameRate: 25
  //   },
  //   // 循环
  //   {
  //     duration: 0.5 + Math.random(),
  //     to: { yoyo: true, repeat: -1, rotation: 0.1 }
  //   }
  // ],
  // 场景一
  s1_cloud2: [
    {
      delay: s1CloudD,
      duration: s1CloudT,
      from: { x: 0 },
      to: { x: -s1Cloud2W }
    }
  ],
  s1_cloud3: [
    {
      delay: s2CloudD,
      duration: s2CloudT,
      from: { x: ww },
      to: { x: -s1Cloud3W }
    }
  ],
  s1_ground1: [
    {
      delay: s1Ground1D,
      duration: s1Ground1T,
      from: { x: 0 },
      to: { x: -s1GroundW }
    }
  ],
  s1_ground2: [
    {
      delay: s1Ground2D,
      duration: s1Ground2T,
      from: { x: ww },
      to: { x: -s1GroundW }
    }
  ],
  s1_static1: [
    {
      delay: s1Static1D,
      duration: s1Static1T,
      from: { x: 0 },
      to: { x: -s1Static1W }
    }
  ],
  s1_static2: [
    {
      delay: s1Static2D,
      duration: s1Static2T,
      from: { x: ww },
      to: { x: -s1Static2W }
    }
  ],
  s1_static3: [
    {
      delay: s1Static3D,
      duration: s1Static3T,
      from: { x: ww },
      to: { x: -s1Static3W }
    }
  ],
  s1_water1: [
    {
      delay: s1Water1D,
      duration: s1Water1T,
      from: { x: ww },
      to: { x: -s1Water1W }
    }
  ],
  s1_shadow: [
    {
      delay: s1WalkD,
      duration: s1WalkT,
      from: { x: ww * 1.1 },
      to: { x: -ww * 0.1 }
    }
  ],
  s1_walk: [
    {
      delay: s1WalkD,
      duration: s1WalkT,
      from: { x: ww * 1.1 },
      to: { x: -ww * 0.1 }
    },
    {
      delay: s1WalkD,
      duration: s1WalkT,
      frames: getFrames('s1_walk', 11, 1)
    }
  ],
  s1_shadow2: [
    {
      delay: s1BikeD,
      duration: s1BikeT,
      from: { x: s1Shadow2X * ww },
      to: { x: s1Shadow2X * ww - s1BikeScrollW }
    }
  ],
  s1_wheel1: [
    {
      delay: s1Wheel1D,
      duration: s1Wheel1T,
      to: { rotation: 30 }
    },
    {
      delay: s1BikeD,
      duration: s1BikeT,
      from: { x: s1Wheel1X * ww },
      to: { x: s1Wheel1X * ww - s1BikeScrollW }
    }
  ],
  s1_wheel2: [
    {
      delay: s1Wheel2D,
      duration: s1Wheel2T,
      to: { rotation: 30 }
    },
    {
      delay: s1BikeD,
      duration: s1BikeT,
      from: { x: s1Wheel2X * ww },
      to: { x: s1Wheel2X * ww - s1BikeScrollW }
    }
  ],
  s1_bike: [
    {
      delay: s1BikeD,
      duration: s1BikeT,
      from: { x: 0.44 * ww },
      to: { x: -0.5 * s1BikeW - s1Wheel2W * 0.5 }
    }
  ],
  s1_hand: [
    {
      duration: 1.5,
      to: { yoyo: true, repeat: -1, rotation: 0.2 }
    },
    {
      delay: s1BikeD,
      duration: s1BikeT,
      from: { x: s1HandX * ww },
      to: { x: s1HandX * ww - s1BikeScrollW }
    }
  ],
  s1_leg: [
    {
      delay: s1LegD,
      duration: s1LegT,
      frames: copyFrames(getFrames('s1_leg', 6, 1), 6)
    },
    {
      delay: s1BikeD,
      duration: s1BikeT,
      from: { x: s1LegX * ww },
      to: { x: s1LegX * ww - s1BikeScrollW }
    }
  ],
  s1_mother: [
    {
      delay: s1BikeD,
      duration: s1BikeT,
      from: { x: s1MotherX * ww },
      to: { x: s1MotherX * ww - s1BikeScrollW }
    }
  ],
  s1_water2: [
    {
      delay: s1Water2D,
      duration: s1Water2T,
      from: { x: ww },
      to: { x: ww - s1Water1ScrollW }
    },
    {
      delay: s1Water2D2,
      duration: s1Water2T2,
      from: { alpha: 0, width: 0, height: 0 },
      to: { alpha: 1, width: s1Water2W, height: s1Water2H, ease: 'ease' }
    },
    {
      delay: s1Water2D3,
      duration: s1Water2T3,
      from: { alpha: 1 },
      to: { alpha: 0 }
    }
  ],
  s1_grass1: [
    {
      delay: s1Grass1D,
      duration: s1Grass1T,
      from: { x: ww },
      to: { x: -s1Grass1W }
    }
  ],
  s1_grass2: [
    {
      delay: s1Grass2D,
      duration: s1Grass2T,
      from: { x: ww },
      to: { x: -s1Grass2W }
    }
  ],
  s1_pole: [
    {
      delay: s1PoleD,
      duration: s1PoleT,
      from: { x: ww },
      to: { x: (-wh * 1912) / 2436 }
    }
  ],
  s1_text: [
    {
      delay: s1TextD,
      duration: s1TextT,
      from: { alpha: 0 },
      to: { alpha: 1, yoyo: true, repeat: 1, repeatDelay: s1TextT * 4 }
    }
  ],
  s1_talk1: [
    {
      delay: s1Talk1D,
      duration: s1Talk1T,
      from: { alpha: 0, width: 0, height: 0 },
      to: { alpha: 1, width: s1Talk1W, height: s1Talk1H, yoyo: true, repeat: 1, repeatDelay: s1Talk1T * 4, ease: 'ease' }
    }
  ],
  s1_talk2: [
    {
      delay: s1Talk2D,
      duration: s1Talk2T,
      from: { alpha: 0, width: 0, height: 0 },
      to: { alpha: 1, width: s1Talk2W, height: s1Talk2H, yoyo: true, repeat: 1, repeatDelay: s1Talk2T * 4, ease: 'ease' }
    }
  ]
}

export default animations



// WEBPACK FOOTER //
// ./src/assets/scenes/s1/spritesAnimations.js